module.exports = __webpack_public_path__ + "static/media/user-default.f1a9e688.jpeg";